export default __webpack_public_path__ + "static/media/plus.98b62eeb.svg";